import { render } from "./LabConversation.vue?vue&type=template&id=74300158"
import script from "./LabConversation.vue?vue&type=script&lang=js"
export * from "./LabConversation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__